// Crisis resources view. Reachable from /coach when the safety classifier
// triggers, and directly via /crisis-resources. Lives OUTSIDE the
// authenticated layout so it's accessible regardless of session state.

import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/crisis-resources')({
  component: CrisisResources,
});

interface Resource {
  region: string;
  name: string;
  contact: string;
  notes?: string;
}

const RESOURCES: Resource[] = [
  { region: 'UK', name: 'Samaritans', contact: '116 123', notes: 'free, 24/7' },
  { region: 'UK', name: 'Shout (text)', contact: 'text SHOUT to 85258', notes: 'free, 24/7' },
  { region: 'US', name: '988 Suicide and Crisis Lifeline', contact: 'call or text 988', notes: 'free, 24/7' },
  { region: 'US', name: 'Crisis Text Line', contact: 'text HOME to 741741' },
  { region: 'Ireland', name: 'Samaritans Ireland', contact: '116 123' },
  { region: 'Canada', name: 'Talk Suicide Canada', contact: 'call 1-833-456-4566', notes: '24/7' },
  { region: 'Australia', name: 'Lifeline', contact: '13 11 14', notes: '24/7' },
  { region: 'New Zealand', name: '1737', contact: 'call or text 1737' },
  { region: 'Germany', name: 'Telefonseelsorge', contact: '0800 111 0 111' },
  { region: 'France', name: '3114', contact: 'call 3114', notes: 'national suicide prevention line' },
  { region: 'Spain', name: 'Teléfono de la Esperanza', contact: '717 003 717' },
  { region: 'Netherlands', name: '113 Zelfmoordpreventie', contact: 'call 113 or 0800-0113' },
  { region: 'International', name: 'findahelpline.com', contact: 'findahelpline.com', notes: 'comprehensive list by country' },
];

function CrisisResources() {
  return (
    <section className="mx-auto max-w-2xl px-4 py-12">
      <h1 className="text-2xl font-semibold tracking-tight">if you are in crisis</h1>
      <p className="mt-3 text-base">
        what you are feeling is real. please reach out to a human.
      </p>
      <p className="mt-2 text-sm text-muted-foreground">
        these lines are staffed by people trained to listen. they will not judge you. you do not need to be in a specific state to call.
      </p>

      <ul className="mt-8 space-y-3">
        {RESOURCES.map((r) => (
          <li key={`${r.region}-${r.name}`} className="rounded-[var(--radius)] border border-border p-4">
            <div className="flex items-baseline justify-between gap-3">
              <div>
                <div className="text-xs uppercase tracking-wide text-muted-foreground">{r.region}</div>
                <div className="font-medium mt-0.5">{r.name}</div>
              </div>
              <div className="text-sm font-mono">{r.contact}</div>
            </div>
            {r.notes && <div className="text-xs text-muted-foreground mt-2">{r.notes}</div>}
          </li>
        ))}
      </ul>

      <div className="mt-10 border-t border-border pt-6 text-sm">
        <Link to="/today" className="text-muted-foreground hover:text-foreground">
          ← back to today
        </Link>
      </div>
    </section>
  );
}
